import type { Filter, RegionalOverviewFilterType } from '@features/regional-overview/regional-overview.models';
import { RegionalOverviewFilterType as FilterTypeEnum } from '@features/regional-overview/regional-overview.models';
import type { ComponentType } from 'react';
import BloomingSection from './blooming-section/blooming-section.component';
import CropsSection from './crops-section/crops-section.component';
import MultiSelectSection from './multi-select-section/multi-select-section.component';
import SowingDateSection from './sowing-date-section/sowing-date-section.component';
import VarietySection from './variety-section/variety-section.component';

export interface SectionProps {
  filter: Filter;
  defaultExpanded?: boolean;
}

export const sectionsRegistry: Partial<Record<RegionalOverviewFilterType, ComponentType<SectionProps>>> = {
  [FilterTypeEnum.RISK_LEVEL]: MultiSelectSection,
  [FilterTypeEnum.TECHNICIAN]: MultiSelectSection,
  [FilterTypeEnum.GROWTH_STAGES]: MultiSelectSection,
  [FilterTypeEnum.DISEASE]: MultiSelectSection,
  [FilterTypeEnum.CROPS]: CropsSection,
  [FilterTypeEnum.VARIETY]: VarietySection,
  [FilterTypeEnum.SOWING_DATE]: SowingDateSection,
  [FilterTypeEnum.GROUPS]: MultiSelectSection,
  [FilterTypeEnum.ZONES]: MultiSelectSection,
  [FilterTypeEnum.PREVIOUS_CROP]: MultiSelectSection,
  [FilterTypeEnum.TILLAGE]: MultiSelectSection,
  [FilterTypeEnum.CLASS]: MultiSelectSection,
  [FilterTypeEnum.BLOOMING]: BloomingSection
};
